import { HttpClient } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { RestApiService } from '../../../../src/app/rest-api.service';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {
	onSettingsChanged: BehaviorSubject<any>;
	/**
   * Constructor
   *
   * @param {HttpClient} _httpClient
   */
	 constructor(public api: RestApiService) {
		// this.onSettingsChanged = new BehaviorSubject({});
	}
	/**
   * Resolver
   *
   * @param {ActivatedRouteSnapshot} route
   * @param {RouterStateSnapshot} state
   * @returns {Observable<any> | Promise<any> | any}
   */
	 resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
		// return new Promise<void>((resolve, reject) => {
		// 	Promise.all([this.getDataTableRows()]).then(() => {
		// 		resolve();
		// 	}, reject);
		// });
	}
  	getDashboardDetails() {
    	return this.api.post("/dashboardCount", {});
  	}

	  getDashboardDetailsForHydrogen() {
    	return this.api.post("/dashboardCountForHydrogen", {});
  	}

	  getDashboardDetailsForCoeProposal() {
    	return this.api.post("/dashboardCountForCoeProposal", {});
  	}

	  getDashboardDetailsForEuttcProposal() {
    	return this.api.post("/dashboardCountForEuttcProposal", {});
  	}
}